/* Reusable styles across multiple components */

import { createTheme } from '@mui/material';

export const createAppTheme = (isAuthenticated: boolean) => {
  return createTheme({
    typography: {
      fontFamily: "'Source Sans 3', sans-serif",
    },
    palette: {
      primary: {
        main: '#ff5f1f',
      },
      background: {
        default: '#ff5f1f',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '999px',
            textTransform: 'none',
            paddingLeft: '24px',
            paddingRight: '24px',
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          input: {
            '&:-webkit-autofill': {
              boxShadow: '0 0 0 1000px white inset',
              WebkitBoxShadow: '0 0 0 1000px white inset',
              WebkitTextFillColor: '#000',
              fontFamily: "'Source Sans 3', sans-serif !important",
              style: 'normal !important',
              fontWeight: 500,
              fontSize: '.9rem !important',
              lineHeight: '1.5 !important',
              letterSpacing: '0.00938em !important',
              transition: 'background-color 5000s ease-in-out 0s',
            },
          },
          body: {
            backgroundColor: 'transparent',
            backgroundImage: isAuthenticated
              ? `url(${process.env.PUBLIC_URL}/assets/main_background.svg)`
              : `url(${process.env.PUBLIC_URL}/assets/login_background.svg)`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: isAuthenticated ? 'top center' : 'bottom right',
            backgroundAttachment: 'fixed',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#ff5f1f',
              '& .MuiTypography-root': {
                fontWeight: 'bold',
              },
            },
            '&.Mui-selected': {
              backgroundColor: 'transparent !important',
              color: '#ff5f1f',
              '& .MuiTypography-root': {
                fontWeight: 'bold',
              },
            },
          },
        },
      },
    },
  });
};
